/**
 * VLT — collection filtering behaviour.
 *
 * The facets form is a plain GET form and works without this file. This
 * script adds: drawer open/close with the shared overlay, auto-submit on
 * checkbox change (debounced for price inputs), and Escape handling.
 * Submission is a full navigation — no history juggling, URLs stay shareable.
 */

(function () {
  'use strict';

  function init() {
    var root = document.querySelector('[data-vlt-collection]');
    if (!root || root.dataset.vltBound) return;
    root.dataset.vltBound = 'true';

    var drawer = document.querySelector('[data-vlt-facets]');
    var openButton = root.querySelector('[data-vlt-facets-open]');
    var closeButton = drawer ? drawer.querySelector('[data-vlt-facets-close]') : null;
    var overlay = document.querySelector('[data-vlt-facets-overlay]');
    var form = drawer ? drawer.querySelector('[data-vlt-facets-form]') : null;
    var sortForm = root.querySelector('[data-vlt-sort-form]');
    var lastFocused = null;

    function setOpen(open) {
      if (!drawer) return;
      if (open) {
        lastFocused = document.activeElement;
        drawer.hidden = false;
        if (overlay) overlay.hidden = false;
        requestAnimationFrame(function () {
          drawer.setAttribute('data-open', '');
          if (overlay) overlay.setAttribute('data-visible', '');
        });
        document.documentElement.style.overflow = 'hidden';
        if (closeButton) closeButton.focus();
      } else {
        drawer.removeAttribute('data-open');
        if (overlay) {
          overlay.removeAttribute('data-visible');
          overlay.hidden = true;
        }
        document.documentElement.style.overflow = '';
        var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.setTimeout(function () {
          drawer.hidden = true;
        }, reduced ? 0 : 420);
        if (lastFocused) lastFocused.focus();
      }
      if (openButton) openButton.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    if (openButton) {
      openButton.addEventListener('click', function () {
        setOpen(drawer.hidden);
      });
    }
    if (closeButton) {
      closeButton.addEventListener('click', function () {
        setOpen(false);
      });
    }
    if (overlay) {
      overlay.addEventListener('click', function () {
        setOpen(false);
      });
    }
    if (drawer) {
      drawer.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') setOpen(false);
      });
    }

    if (form) {
      var priceTimer = null;

      form.addEventListener('change', function (event) {
        if (event.target.matches('input[type="number"]')) {
          // Debounce price edits so typing "150" doesn't submit at "1".
          window.clearTimeout(priceTimer);
          priceTimer = window.setTimeout(function () {
            form.requestSubmit();
          }, 700);
        } else {
          form.requestSubmit();
        }
      });
    }

    if (sortForm) {
      var select = sortForm.querySelector('select');
      if (select) {
        select.addEventListener('change', function () {
          sortForm.requestSubmit();
        });
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
